export default {"src":"/_next/static/media/commsor.8bbf64e6.svg","height":32,"width":396,"blurWidth":0,"blurHeight":0};